import React, { useEffect, useState } from 'react';

import { useToastAction } from '../../hooks/useToastAction.js';

import { getClientInfo } from "../../api/storage.js"

import { ServerInformationContext } from '..';

export const ServerInformationProvider = ({ children }) => {

  const loadAction = useToastAction();

  const [visible, setVisible] = useState(false);
  const [usePanelWrapper, setUsePanelWrapper] = useState(false);
  const [usePanelIcon, setUsePanelIcon] = useState(true);
  const [panelContent, setPanelContent] = useState(null);
  const [hubClients, setHubClients] = useState(null);
  
  const loadBaseData = async () => {
    loadAction.execute(async () => {
      console.log("ServerInformationProvider", "loadBaseData");

      const [clients] = await Promise.all([getClientInfo()]);
      console.log("ServerInformationProvider", "loadBaseData", "clients", clients);

      setHubClients(clients);
    }, "Failed to load (ServerInformationProvider)")
  }

  useEffect(async () => {
    await loadBaseData();
  }, []);

  const showSystemInfoPanel = (content, usePanel, useIcon = true) => {
    //console.log("ServerInformationProvider", "showSystemInfoPanel", "content", content, "usePanel", usePanel);
    setVisible(true);
    setUsePanelWrapper(!!usePanel);
    setUsePanelIcon(useIcon)
    setPanelContent(content);
  }

  const hideSystemInfoPanel = (clearContent) => {
    //console.log("ServerInformationProvider", "showSystemInfoPanel", "clearContent", clearContent);
    setVisible(false);
    if (clearContent) {
      setUsePanelWrapper(false);
      setPanelContent(null);
    }
  }
  return (
    <ServerInformationContext.Provider
      value={{
        hubClients: hubClients,
        setHubClients,
        systemInfoPanelVisible: visible,
        usePanelWrapper: usePanelWrapper,
        usePanelIcon: usePanelIcon,
        panelContent: panelContent,
        showSystemInfoPanel,
        hideSystemInfoPanel
      }}
    >
      {children}
    </ServerInformationContext.Provider>
  );
}
